<template>
  <v-card flat>
    <v-list subheader class="pb-0">
      <template v-for="(item, index) in items">
        <v-list-item
          :key="index"
          @click="selectedItem(item)"
          class="cardErrorBorder"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium title">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider :key="index + 100"></v-divider>
      </template>
      <v-list-item v-if="total > items.length">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium title">
            {{ total - items.length }} more...
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    items: Array,
    total: Number
  },
  data() {
    return {};
  },
  methods: {
    selectedItem(item) {
      this.$emit('view', item);
    }
  }
};
</script>
